import { Children, MouseEventHandler, ReactNode, useLayoutEffect, useRef } from 'react';
import {
	PanelContainer,
	PanelContent,
	Header,
	Main,
	Buttons,
	Title,
} from './style';
import Button from 'components/Basic/Button';
import { useRefDispatch } from 'contexts/RefContext';
import { ToolCancelButton } from 'components/tool/Editor/ButtonDiv/CancelButton/cancelButton';

type Props = {
  title?: string;
  children: ReactNode;
  open?: boolean;
  doneBtnLabel?: ReactNode;
  closeBtnLabel?: ReactNode;
	onAction?: MouseEventHandler<HTMLButtonElement>;
	onClose?: MouseEventHandler<HTMLButtonElement>;
	actionLoader: boolean;
	disableAction: boolean;
	showActionBtn?: boolean;
	position?: 'right' | 'bottom';
	containerClassName?: string;
	panelClassName?: string;
	deleteBtn?: ReactNode;
	closeBtnClassName?: string;
};

export default function SidePanel(props: Props) {
	const {
		title,
		children,
		open = false,
		doneBtnLabel = 'Done',
		closeBtnLabel = 'Close',
		actionLoader,
		disableAction,
		onAction,
		onClose,
		showActionBtn = true,
		position = 'right',
		containerClassName,
		panelClassName,
		deleteBtn,
		closeBtnClassName,
	} = props;

	const panelRef = useRef<HTMLDivElement | null>(null);
	const refDispatch = useRefDispatch();

	useLayoutEffect(() => {
		refDispatch({ type: 'ADD_SIDE_PANEL_DIV_REF', payload: { ref: panelRef } });
	}, [refDispatch]);

	const containerClassNames = [
		'side-panel-container',
		position === 'bottom' ? 'side-panel-container--bottom' : 'side-panel-container--right',
		containerClassName,
	].filter(Boolean).join(' ');
	const panelClassNames = [
		'side-panel',
		position === 'bottom' ? 'side-panel--bottom' : 'side-panel--right',
		panelClassName,
	].filter(Boolean).join(' ');
	const hasChildren = Children.count(children) > 0;
	const shouldRenderHeader = hasChildren || position === 'bottom';

	return (
		<PanelContainer className={containerClassNames} $position={position}>
			<PanelContent
				ref={panelRef}
				$open={open}
				$position={position}
				className={panelClassNames}
				data-position={position}
				data-open={open}
			>
				{shouldRenderHeader && (
					<Header>
						{title && <Title>{title}</Title>}
						<Buttons>
							{deleteBtn}
							<ToolCancelButton
								id="sidepanel-close"
								disabled={actionLoader}
								className={`side-modal-close ${closeBtnClassName || ''}`}
								label={closeBtnLabel}
								onClick={onClose}
							/>
							{showActionBtn && <Button id="sidepanel-done" disabled={disableAction} showLoader={actionLoader} onClick={onAction}
								className='sidepanel-done'>{doneBtnLabel}</Button>
							}
						</Buttons>
					</Header>
				)}

				{hasChildren && <Main>{children}</Main>}
			</PanelContent>
		</PanelContainer>
	);
}
